// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"942":"ea295c05","2263":"66cc27ce","2595":"386bba39","5470":"c9e5f09b","7599":"ea295c05"}[chunkId] + ".chunk.css";
};